import React from "react";
import CreateSectionHeader from "../CreateNotice/CreateSectionHeader";
import { CERTIFICATES_CRUMB } from "./certificateCrumbs";

// Shared by each page and the placeholder shown while its code downloads.

export const CertificatesHomeHeader: React.FC = () => (
  <CreateSectionHeader
    crumbs={[]}
    title="Certificates"
    subtitle="Design a certificate template, then use it to give certificates to your Awardees."
  />
);

export const CertificateTemplatesHeader: React.FC<{ count?: number }> = ({ count }) => (
  <CreateSectionHeader
    crumbs={[CERTIFICATES_CRUMB]}
    title={count === undefined ? "Templates" : `Templates (${count})`}
    subtitle="Design a certificate template once, then use it for any Award."
  />
);

export const AwardsHeader: React.FC = () => (
  <CreateSectionHeader
    crumbs={[CERTIFICATES_CRUMB]}
    title="Awards"
    subtitle="An Award gives certificates to a list of Awardees, such as Maths Olympics – Gold."
  />
);
